module.exports = __webpack_public_path__ + "img/icon-catalog.657953c3.png";